export const SONGS_LIST_STRINGS = {
  request: 'Request',
  songs: (count: number) => (count === 1 ? '1 song' : `${count} songs`),
  approval: 'Approval',
  copyright: 'Copyright',
  details: 'Request details',
  chat: 'Chat',
  share: 'Share request',
  close: 'Close',
  sendReview: 'Confirm',
  answeredCount: (answered: number, total: number) => `${answered} of ${total} ${total === 1 ? 'song' : 'songs'} answered`,
  notOwned: 'Not owned',
  copyrightNotice: 'Copyright notice',
  copyrightPlaceholder: 'e.g. © 2008 Publisher Name. All rights reserved.',
  printShare: 'Print share',
  digitalShare: 'Digital share',
  comment: 'Comment',
  answeredOn: (date: string) => `Answered on ${date}`,
  withdrawnTitle: 'Request withdrawn',
} as const

export const SONG_ACTION_BUTTONS_STRINGS = {
  approved: 'Approved',
  approve: 'Approve',
  rejected: 'Rejected',
  reject: 'Reject',
  counteroffered: 'Counteroffered',
  reason: 'Reason',
  submit: 'Submit',
  cancel: 'Cancel',
} as const

export const SONG_STATUS_BLOCK_STRINGS = {
  approved: 'Approved',
  rejected: 'Rejected',
  counteroffer: 'Counteroffer',
} as const
